<script setup lang="ts">
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import Button from '~/components/Common/Button/Button.vue'

defineProps<{
	show: boolean
	title?: string
	icon?: string
	message?: string
	type?: 'error' | 'success'
	buttons?: {
		text: string
		handler: () => void
		btnClass: 'btn-primary' | 'btn-muted'
	}[]
}>()

const emits = defineEmits(['close'])
</script>

<template>

<TransitionRoot as="template" :show="show">
    <Dialog class="relative z-10" @close="emits('close')">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
              <div class="sm:flex sm:items-start">
                <div v-if="icon" :class="['mx-auto flex size-12 shrink-0 items-center justify-center rounded-full sm:mx-0 sm:size-10', type === 'error' ? 'bg-red-100' : 'bg-green-100']">
                  <Icon :name="icon" :size="20" :class="[type === 'error' ? 'bg-red-500' : 'bg-green-500']" />
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <DialogTitle v-if="title" as="h3" class="text-base font-semibold text-gray-900">{{title}}</DialogTitle>
                  <div class="mt-2" v-if="message">
                    <p class="text-sm text-gray-500">{{message}}</p>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:ml-10 sm:mt-4 sm:flex sm:pl-4 gap-4">
				<Button v-for="button in buttons" :key="button.text" :btnClass="button.btnClass" @click="button.handler">{{button.text}}</Button>
			  </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>


</template>
